import script from "./ShopCreateForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShopCreateForm.vue?vue&type=script&setup=true&lang=ts"

import "./ShopCreateForm.vue?vue&type=style&index=0&id=e5e0b40c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5e0b40c"]])

export default __exports__